import React from "react";
import OrderTab from "../../enum/OrderTab";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTableColgroup from "./OrderTableColgroup";
import OrderTableHead from "./OrderTableHead";
import { useOrderManagementStore } from "../../store/OrderManagementStore";
import VirtualizedTable from "@/scenes/OrderManagementForAllShop/components/VirtualizedTable";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderRow from "./OrderRow";
import { observer } from "mobx-react-lite";
import useShiftClickOrderCheckbox from "../../hooks/useShiftClickOrderCheckbox";
import type { OrderTableColumn } from "../../store/OrderTableStorageStore/utils/orderTableColumns";
import { getRenderableOrderTableColumns } from "./utils";
import OrderTableEmpty from "./OrderTableEmpty";
import useClickTdAutoToggleOrderSelect from "../../hooks/useClickTdAutoToggleOrderSelect";

interface VirtualizedTableWrapProps {
    tab: OrderTab;

    shop: ShopDTO;

    isQianniu?: boolean;

    isSupplierShop: boolean;

    isShowFulfillment: boolean;
}

interface OrderRenderRowProps {
    tab: OrderTab;

    isQianniu?: boolean;

    index: number;

    data: OrderDTO;

    shop?: ShopDTO;

    isSupplierShop: boolean;

    visibleColumns?: OrderTableColumn[];
}

const OrderRenderRow: React.FC<OrderRenderRowProps> = observer(function (props) {
    const { tab, isQianniu, shop, isSupplierShop, index, data: order, visibleColumns } = props;

    return (
        <OrderRow
            order={order}
            key={`${order.id}_${index}`}
            index={index}
            isSupplierShop={isSupplierShop}
            shop={shop}
            isQianniu={isQianniu}
            tab={tab}
            visibleColumns={visibleColumns}
        />
    );
});

const VirtualizedTableWrap: React.FC<VirtualizedTableWrapProps> = observer(function (props) {
    const { tab, shop, isQianniu, isSupplierShop, isShowFulfillment } = props;

    const orderManagementStore = useOrderManagementStore();

    const orders = orderManagementStore.table.orders;
    const visibleColumns = getRenderableOrderTableColumns(orderManagementStore.storage.sortedColumns, tab);
    const orderCount = orders?.length || 0;

    useShiftClickOrderCheckbox();
    useClickTdAutoToggleOrderSelect({
        toggleOrderSelect: orderManagementStore.table.toggleOrderSelect,
        refreshKey: orderCount,
    });

    if (!orders || orderCount === 0) {
        const fulfillmentType = orderManagementStore?.table?.listOptions?.fulfillmentType;

        return (
            <table className="table table-bordered order-table">
                <OrderTableColgroup tab={tab} />
                <OrderTableHead tab={tab} shop={shop} />
                <OrderTableEmpty
                    shop={shop}
                    fulfillmentType={fulfillmentType}
                    isShowFulfillment={isShowFulfillment}
                    tab={tab}
                />
            </table>
        );
    }

    return (
        <VirtualizedTable
            data={orders}
            prefix={<OrderTableColgroup tab={tab} />}
            thead={<OrderTableHead tab={tab} shop={shop} />}
            RenderRow={OrderRenderRow}
            onVirtualizedTableStoreChange={orderManagementStore.table.onVirtualizedTableStoreChange}
            renderRowProps={{
                tab,
                isQianniu,
                shop,
                isSupplierShop,
                visibleColumns,
            }}
        />
    );
});

export default VirtualizedTableWrap;
